import api from './api';

export const fetchAllTransfers = async ({ queryKey }) => {
  const [, { page, limit, search, orderBy, fetch }] = queryKey;
  let url = `/transfers/state/all?page=${page}&limit=${limit}`;
  
  if (search) {
    url += `&search=${search}`;
  }
  if (orderBy) {
    url += `&orderBy=${orderBy}`;
  }
  if (fetch) {
    url += `&fetch=${fetch}`;
  }

  const response = await api.get(url);
  return response.data;
};

export const fetchInflowTransfers = async ({ queryKey }) => {
  const [, { page, limit, search, orderBy, fetch , status, searchBy, searchByExactMatch }] = queryKey;
  let url = `/transfers/state/inflows?page=${page}&limit=${limit}`;
  
  if (search) {
    url += `&search=${search}`;
  }
  if (orderBy) {
    url += `&orderBy=${orderBy}`;
  }
  if (fetch) {
    url += `&fetch=${fetch}`;
  }
  if (status) {
    url += `&status=${status}`;
  }
  if (searchBy && Array.isArray(searchBy)) {
    const params = searchBy.map((field) => `searchBy=${field}`).join('&');
    url += `&${params}`;
  }
  if (searchByExactMatch) {
    url += `&searchByExactMatch=${searchByExactMatch}`;
  }

  const response = await api.get(url);
  return response.data;
}
export const fetchOutlowTransfers = async ({ queryKey }) => {
  const [, { page, limit, search, orderBy, fetch, status, searchBy, searchByExactMatch }] = queryKey;
  let url = `/transfers/state/outflows?page=${page}&limit=${limit}`;
  
  if (search) {
    url += `&search=${search}`;
  }
  if (orderBy) {
    url += `&orderBy=${orderBy}`;
  }
  if (fetch) {
    url += `&fetch=${fetch}`;
  }
  if (status) {
    url += `&status=${status}`;
  }
  if (searchBy && Array.isArray(searchBy)) {
    const params = searchBy.map((field) => `searchBy=${field}`).join('&');
    url += `&${params}`;
  }
  if (searchByExactMatch) {
    url += `&searchByExactMatch=${searchByExactMatch}`;
  }

  const response = await api.get(url);
  return response.data;
}

export const fetchTransfer = async ({ queryKey }) => {
  const [, { id, type }] = queryKey;
  const response = await api.get(`/transfers/${id}?type=${type}`);
  return response.data;
};

export const fetchTransferMetrics = async ({ queryKey }) => {
  const [, { fetch }] = queryKey;
  let url = `/transfers/metrics?fetch=${fetch}`;
  const response = await api.get(url);
  return response.data;
};

export const exportTransfer = async (event, data) => {
  const response = await api.post(`/export/transfer?event=${event}`, data);
  return response.data;
}

export const transferReconciliation = async (data) => {
  const response = await api.patch(`/reconciliation/transfer`, data);
  return response.data;
}